import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classcat';
import { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import Bingo from 'modules/Bingo';

const STAGE = Bingo.constants.STAGE;
const STATUS = Bingo.constants.STATUS;

export const _Card90 = ({ inProgressStatus, inPlay, stage }) => {
  const oneLineWon = inProgressStatus === STATUS.ONE_LINE_JACKPOT_WON;
  const twoLinesWon = inProgressStatus === STATUS.TWO_LINES_JACKPOT_WON;
  const gameWon = inProgressStatus === STATUS.GAME_FINISHED;
  const firstRowClass = classNames([
    'row',
    {
      active: oneLineWon || twoLinesWon || gameWon || !inPlay,
      waiting:
        inPlay && (stage === STAGE.WAITING_FIRST_LINE || stage === STAGE.WAITING_FIRST_TWO_LINES)
    }
  ]);
  const secondRowClass = classNames([
    'row',
    {
      active: twoLinesWon || gameWon || !inPlay,
      waiting:
        inPlay &&
        (stage === STAGE.WAITING_SECOND_LINE ||
          stage === STAGE.WAITING_FIRST_TWO_LINES ||
          stage === STAGE.WAITING_LAST_TWO_LINES)
    }
  ]);
  const thirdRowClass = classNames([
    'row',
    {
      active: gameWon || !inPlay,
      waiting: inPlay && (stage === STAGE.WAITING_THREE_LINES || stage === STAGE.WAITING_THIRD_LINE)
    }
  ]);
  return (
    <div className="card card--90">
      <div>
        <div className="inner">
          <div className={firstRowClass}>
            <div className="cell" />
            <div className="cell" />
            <div className="cell" />
            <div className="cell" />
            <div className="cell" />
            <div className="cell" />
            <div className="cell" />
            <div className="cell" />
            <div className="cell" />
          </div>
          <div className={secondRowClass}>
            <div className="cell" />
            <div className="cell" />
            <div className="cell" />
            <div className="cell" />
            <div className="cell" />
            <div className="cell" />
            <div className="cell" />
            <div className="cell" />
            <div className="cell" />
          </div>
          <div className={thirdRowClass}>
            <div className="cell" />
            <div className="cell" />
            <div className="cell" />
            <div className="cell" />
            <div className="cell" />
            <div className="cell" />
            <div className="cell" />
            <div className="cell" />
            <div className="cell" />
          </div>
        </div>
      </div>
    </div>
  );
};

_Card90.propTypes = {
  inPlay: PropTypes.bool,
  inProgressStatus: PropTypes.string,
  stage: PropTypes.string
};

_Card90.defaultProps = {
  inPlay: false,
  stage: null,
  inProgressStatus: ''
};

export default _Card90;
